import { Component, Input, OnInit } from "@angular/core";
import { MenuItem, ScrollPanel } from "primeng/primeng";
import { AuthenticationService } from "src/app/services/authentication.service";

@Component({
    selector: "app-menu",
    templateUrl: "./menu.component.html",
})
export class AppMenuComponent implements OnInit {
    constructor(private authService: AuthenticationService) {}

    @Input() scrollerViewChild: ScrollPanel;

    isAdmin: boolean;
    isManager: boolean;

    adminModel: MenuItem[] = [
        {
            label: "Dashboard",
            icon: "fa fa-fw fa-bar-chart",
            routerLink: ["/core/dashboard"],
        },
        {
            label: "User Management",
            icon: "fa fa-fw fa-user-o",
            items: [
                {
                    label: "Users",
                    icon: "fa fa-fw fa-folder",
                    routerLink: ["/core/users"],
                },
                {
                    label: "Roles",
                    icon: "fa fa-fw fa-folder",
                    routerLink: ["/core/roles"],
                },
            ],
        },
        {
            label: "Setup",
            icon: "fa fa-fw fa-cog",
            items: [
                {
                    label: "Companies",
                    icon: "fa fa-fw fa-folder",
                    routerLink: ["/core/setups"],
                },
                {
                    label: "Distributors",
                    icon: "fa fa-fw fa-folder",
                    routerLink: ["/core/setups/distributor"],
                },
                {
                    label: "Email Templates",
                    icon: "fa fa-fw fa-at",
                    routerLink: ["/core/setups/email-templates"],
                },
            ],
        },
    ];

    managerModel: MenuItem[] = [
        {
            label: "Dashboard",
            icon: "fa fa-fw fa-bar-chart",
            routerLink: ["/core/dashboard"],
        },
        {
            label: "Companies",
            icon: "fa fa-fw fa-building-o",
            routerLink: ["/core/setups"],
        },
        {
            label: "Distributors",
            icon: "fa fa-fw fa-folder",
            routerLink: ["/core/setups/distributor"],
        },
    ];

    userModel: MenuItem[] = [
        {
            label: "Dashboard",
            icon: "fa fa-fw fa-bar-chart",
            routerLink: ["/core/dashboard"],
        },
        {
            label: "Products",
            icon: "fa fa-fw fa-bars",
            routerLink: ["/core/setups/product-client"],
        },
        {
            label: "Distributors",
            icon: "fa fa-fw fa-folder",
            routerLink: ["/core/setups/distributor-client"],
        },
    ];

    model: MenuItem[];

    ngOnInit() {
        this.isAdmin = this.authService.isAdmin();
        this.isManager = this.authService.isManager();
        this.model = this.isAdmin
            ? this.adminModel
            : this.isManager
              ? this.managerModel
              : this.userModel;
    }
}
